import React, { useState } from 'react';
import Image from 'next/image';
import BannerCard from './banner-card';
import { Translate } from '~/i18n';
import { useAuth, useAccountStatus } from '~/auth';
import { AccountStatuses } from '~/auth/use-account-status';
import { useTranslate } from '~/i18n';
import usePayoutInfo from '~/apis/payout/usePayoutInfo';
import GoToBankInfoModal from '~/components/payout/go-to-bank-info-modal';
import { CheckedListItem, UserIcon } from '~/svgs';
import { SubmitLoader } from '~/components/common/loaders/submit';

const ProfileBanner = ({ isInternationalUser }: { isInternationalUser?: boolean }) => {
   const [openModal, setOpenModal] = useState(false);
   const { user, userLoading } = useAuth();
   const { lang } = useTranslate();
   const { status } = useAccountStatus();
   const { data: userPayout, isLoading } = usePayoutInfo();
   const { current_user, business_name } = user || {};

   // const onRequestPayout = () => {
   //    if (profile_strength?.user_has_bank_info) {
   //       return router.push(`/${lang}/payout-request`);
   //    } else {
   //       setOpenModal(true);
   //    }
   // };
   return (
      <div className="relative h-64 mb-5 text-white rounded-default bg-primary xl:h-44">
         <Image
            className="rounded-default"
            src="/images/profile/sta-profile-banner_blue.png"
            layout="fill"
         />
         <div className="absolute flex flex-col items-center w-full h-full p-4 xl:flex-row xl:space-x-2 xl:justify-between xl:p-6">
            {userLoading ? (
               <div className="flex justify-center w-full my-auto">
                  <SubmitLoader />
               </div>
            ) : (
               <div className="flex items-center justify-center h-full">
                  <div className="flex mx-3 bg-grey-400 p-5 rounded-full w-[80px] h-[80px] items-center justify-center">
                     <UserIcon width={40} height={40} />
                  </div>

                  <div className="flex flex-col space-y-3">
                     <div className="flex items-center gap-2">
                        <div className="text-xl font-bold xl:text-2xl">
                           {business_name?.[lang] || business_name?.en}
                        </div>
                        {status === AccountStatuses.Completed && (
                           <div className="flex font-bold px-2 max-w-min py-0.5 uppercase space-x-2 items-center rtl:space-x-reverse bg-green-100 text-[10px] rounded-default text-[#00983F]">
                              <div>
                                 <CheckedListItem className="!h-3 !w-3" />
                              </div>
                              <div>
                                 <Translate id="profile:verified" />
                              </div>
                           </div>
                        )}
                        {status === AccountStatuses.UnderReview && (
                           <div className="whitespace-nowrap font-bold px-2 max-w-min py-0.5 uppercase bg-[#fff8ea] text-[#FFB023] text-[10px] rounded-default">
                              <div>
                                 <Translate id="dashboard:under review" />
                              </div>
                           </div>
                        )}
                     </div>

                     <span className="text-sm">{current_user?.name}</span>
                  </div>
               </div>
            )}

            {!isInternationalUser ? (
               <div className="flex mt-3 space-x-1 sm:space-x-2 rtl:space-x-reverse lg:mt-0">
                  <BannerCard
                     isLoading={isLoading}
                     title={<Translate id="dashboard:total sales" />}
                     amount={userPayout?.total_balance}
                  />
                  <BannerCard
                     isLoading={isLoading}
                     title={<Translate id="profile:eligible for payout" />}
                     amount={userPayout?.total_claim_balance}
                     // handelRequestButton={() => onRequestPayout()}
                  />
               </div>
            ) : null}
         </div>
         <GoToBankInfoModal open={openModal} setOpen={setOpenModal} />
      </div>
   );
};

export default ProfileBanner;
